
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { User } from '@/modules/authentication/models/user';
import {
  AnalysisRequest,
  AnalysisRequestSubject,
  SampleBatch,
  ChatMessage,
  FactAnalysisRequest,
  ResultFile
} from '@/modules/analysis/models/analysisRequest';
import AboutSubject from '@/modules/analysis/components/display-request/AboutSubject.vue';
import AboutApplicant from '@/modules/analysis/components/display-request/AboutApplicant.vue';
import AboutSampleBatch from '@/modules/analysis/components/display-request/AboutSampleBatch.vue';
import AboutChatMessage from '@/modules/analysis/components/display-request/AboutChatMessage.vue';
import AboutFact from '@/modules/analysis/components/display-request/AboutFact.vue';
import AboutResultFile from '@/modules/analysis/components/display-request/AboutResultFile.vue';
import * as AnalysisRequestService from '@/modules/analysis/services/analysisRequestService';
import { RequestStatusEnum } from '@/modules/analysis/models/requestStatusEnum';

@Component({
  components: { AboutSubject, AboutApplicant, AboutSampleBatch, AboutChatMessage, AboutFact, AboutResultFile }
})
export default class DisplayAnalysis extends Vue {
  @Action('analysis/readAnalysisRequest')
  protected readAnalysisRequest!: (idParam: string) => Promise<AnalysisRequest>;
  protected analysisRequest: AnalysisRequest | null = null;

  protected created(): void {
    this.readAnalysisRequest(this.$route.params.id)
      .then((request) => {
        this.analysisRequest = request;
        this.reloadChatMessages();
      })
      .catch((e) => {
        if (e.status === 404) {
          this.$router.push({ name: '404' });
        }
      });
  }

  protected reloadChatMessages(): void {
    if (this.analysisRequest?.id) {
      AnalysisRequestService.getChatMessages(this.analysisRequest.id).then((response) => {
        if (this.analysisRequest) {
          this.analysisRequest.chatMessages = response.data;
        }
      });
    }
  }

  protected reloadResultFiles(): void {
    if (this.analysisRequest?.id) {
      AnalysisRequestService.getResultFiles(this.analysisRequest.id).then((response) => {
        if (this.analysisRequest) {
          this.analysisRequest.resultsFiles = response.data;
        }
      });
    }
  }

  protected onAnalysisChange(analysisUpdated: AnalysisRequest): void {
    this.analysisRequest = analysisUpdated;
  }

  protected get requestId(): string | null {
    return this.analysisRequest?.id || null;
  }

  protected get subject(): AnalysisRequestSubject | null {
    return this.analysisRequest?.subject || null;
  }

  protected get sampleBatches(): SampleBatch[] | null {
    return this.analysisRequest?.sampleBatches || null;
  }

  protected get applicant(): User | null {
    return this.analysisRequest?.applicant || null;
  }

  protected get facts(): FactAnalysisRequest[] | null {
    return this.analysisRequest?.facts || null;
  }

  protected get resultFiles(): ResultFile[] | null {
    return this.analysisRequest?.resultsFiles || null;
  }

  protected get chatMessages(): ChatMessage[] | null {
    return this.analysisRequest?.chatMessages || null;
  }

  protected get isReadOnly(): boolean {
    return this.analysisRequest?.currentStatus !== RequestStatusEnum.IN_PROGRESS;
  }
}
